<template>
  <div>
    The maneuver comparator details each scenario previously selected in the
    "Evasive scenarios" table.

    <br />
    <br />

    Each scenario is depicted as a vertical card with the following information
    :
    <ul>
      <li>
        <b>Target evasive maneuvers</b> : The maneuvers performed by the target
        object along with additional data such as the updated close approach
        date and associated distance.
      </li>
      <li>
        <b>Relative distance between the two spacecrafts</b> : The relative
        distance vs time between the chaser and the target (reference scenario +
        evasive scenario).
      </li>
      <li>
        <b>3D relative chaser position</b> : The relative position of the chaser
        in 3D (reference scenario + evasive scenario). The graph is displayed in
        TNW frame and is centered at the target position meaning the target is
        located at (0,0,0).
      </li>
      <li>
        <b>Relative distance along each axis</b> : Custom graphs can be
        displayed via this option. The user can select which dimension to
        display on each axis (example : T vs N).
      </li>
    </ul>

    <br />
    <b>Additional options : </b>
    <ul>
      <li>Display chaser reaction maneuvers</li>
      <li>Display target distance to nominal trajectory</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipEvasiveManeuverComparator'
}
</script>
